<template>
    <v-col cols="12" xl="3" md="6" sm="12" class="p-0 px-1">
        <div
            v-if="(item.route && can(item.route)) || true"
            :class="`upload-card ${item.color ? `bgc-${item.color} ${item.color}--text` : ''}`"
        >
            <div class="upload-card-title">
                <div class="title">
                    <h1>
                        <v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
                        {{ item.title }}
                    </h1>
                </div>
            </div>
            <div class="upload-card-actions">
                <slot name="action"></slot>
            </div>
        </div>
    </v-col>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
};
</script>
